import React, { useEffect, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as EnvioHttp from '../../../../services/api/https/deliveries/envio-rota.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  InputNumeroInteiro,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'

function ModalDescarregarElement({
  frota,
  isVisible,
  onClose,
  dispatch,
  hasOrdemCarregamento = null,
}) {
  const [modalEntregas, setModalEntregas] = useState(frota.deliveries)
  const [globalFilter, setGlobalFilter] = useState('')
  const [allSelected, setAllSelected] = useState(false)

  useEffect(() => {
    setModalEntregas(frota.deliveries)
  }, [frota])

  //Events
  const onCheckBoxRowClicked = (entrega, checked) => {
    const index = modalEntregas.findIndex(e => e.step_id === entrega.step_id)
    if (index !== -1) {
      modalEntregas[index].selected = checked
      setModalEntregas([...modalEntregas])
    }
  }
  const btnDescarregarClicked = async () => {
    dispatch(showLoadingBox('Aguarde...', 'Descarregando Veiculo'))
    try {
      const fetchedFrotas = await EnvioHttp.descarregarDeliveries(
        modalEntregas.filter(e => e.selected).map(r => r.associacao_id),
      )
      dispatch(showMessageBox('Descarga realizada com Sucesso', null))
      onClose(fetchedFrotas)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onSelectAllCheck = value => {
    setModalEntregas(modalEntregas.map(e => ({ ...e, selected: value })))
    setAllSelected(value)
  }

  const onOrdemCarregamentoChange = (entrega, value) => {
    const index = modalEntregas.findIndex(e => e.associacao_id === entrega.associacao_id)
    if (index !== -1) {
      modalEntregas[index].load_order = value
      setModalEntregas([...modalEntregas])
    }
  }

  const showColumnOrdemCarregamento = hasOrdemCarregamento => {
    if (hasOrdemCarregamento)
      return (
        <Column
          header={'Ordem Carregamento'}
          style={tableCellCentered(120)}
          body={entrega => (
            <InputNumeroInteiro
              onChange={value => onOrdemCarregamentoChange(entrega, value)}
              value={entrega.load_order}
              marginTop={0}
            />
          )}
        />
      )
  }

  const saveOrdemDeCarregamento = () => {
    dispatch(showLoadingBox('Aguarde...', 'Salvando ordem de carregamento'))
    try {
      if (!todasAsEntregasPossuemOrdemDeCarregamento(modalEntregas)) {
        dispatch(showMessageBox(null, 'Existe entrega sem Ordem de Separação associada'))
        dispatch(hideLoadingBox())
      } else {
        EnvioHttp.setLoadOrder(modalEntregas)
          .then(() => {
            dispatch(showMessageBox('Ordem associada com sucesso', null))
            onClose()
          })
          .catch(err => {
            dispatch(showMessageBox(null, errorHandler(err)))
            dispatch(hideLoadingBox())
          })
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const todasAsEntregasPossuemOrdemDeCarregamento = entregas => {
    let result = true
    entregas.forEach(e => {
      if (Number.isNaN(e.ordem_carregamento) || Number(e.ordem_carregamento) <= 0) {
        result = false
      }
    })
    return result
  }

  return (
    <CustomModal
      width="80%"
      maximizable={true}
      header={
        <span>
          Entregas - <strong>{frota.vehicle_badge}</strong>
        </span>
      }
      isVisible={isVisible}
      onClose={() => onClose(null)}
    >
      <div className="p-grid">
        <div style={{ paddingLeft: 20, paddingTop: 12 }}>
          <CustomCheckbox checked={allSelected} onChange={value => onSelectAllCheck(value)}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div style={{ paddingLeft: 8 }}>
          <Btn onClick={btnDescarregarClicked}>Descarregar</Btn>
        </div>
        <div style={{ paddingLeft: 8, display: hasOrdemCarregamento ? 'inline-block' : 'none' }}>
          <Btn onClick={saveOrdemDeCarregamento}>Salvar Ordem de Carregamento</Btn>
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <DataTable
          value={modalEntregas}
          rows={5}
          paginator={true}
          header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          globalFilter={globalFilter}
          className="auto-layout"
        >
          <Column
            style={tableCellCentered(60)}
            body={entrega => (
              <CustomCheckbox
                checked={entrega.selected}
                onChange={checked => onCheckBoxRowClicked(entrega, checked)}
              />
            )}
          />
          <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
          <Column field="company_name" header="Empresa" style={tableCellCentered(120)} />
          <Column field="razao_social" header="Razão Social" />
          <Column field="city" header="Cidade" />
          <Column field="district" header="Bairro" />
          <Column field="qte_sku" header="Qte. SKUs" style={tableCellCentered(80)} />
          <Column field="weight" header="Peso" style={tableCellCentered(80)} />
          {showColumnOrdemCarregamento(hasOrdemCarregamento)}
        </DataTable>
      </div>
    </CustomModal>
  )
}
export default connect()(ModalDescarregarElement)
